import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAreaLevel } from '../../reducer/areaLevelSlice';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter, useGridApiRef } from '@mui/x-data-grid-pro';
import { Box, Button, IconButton, LinearProgress, Typography } from '@mui/material';
import { getAmphurDataMap, getProvinceDataMap, getRegionDataMap, getTambonDataMap } from '../../reducer/areaDataSlice';
import { getAreaSelected } from '../../reducer/areaSelectedSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';

import dayjs from 'dayjs';
import { getIAAM } from '../../reducer/iaamSlice';
import DengueEOCLegeng from '../legend/DengueEOCLegeng';

const autoSizeOptions = {
    // columns: ['value', 'result'],
    includeOutliers: true,
    includeHeaders: true,
    expand: true
}

function RenderEOC(props) {
    if (props.value) {
        return (<CheckCircleIcon sx={{ color: '#1150A4', width: "20px" }} />)
    } else {
        return (<CancelIcon className='w-5 h-5 text-gray-300' />)
    }
}

function RenderEOCisOpened(props) {
    if (props.value) {
        return (<CheckCircleIcon sx={{ color: '#cd6c4a', width: "20px" }} />)
    } else {
        return (<CancelIcon className='w-5 h-5 text-gray-300' />)
    }
}



function MonitorTable(props) {
    // const profile = useSelector(getProfile);
    const iaam = useSelector(getIAAM);
    const areaLevel = useSelector(getAreaLevel);
    const areaSelected = useSelector(getAreaSelected);
    const woy = useSelector(getWeekOfYear);
    const regionMap = useSelector(getRegionDataMap);
    const provinceMap = useSelector(getProvinceDataMap);
    const amphurMap = useSelector(getAmphurDataMap);
    const tambonMap = useSelector(getTambonDataMap);
    const [columns, setColumns] = useState([]);
    const [pinColumns, setPinColumns] = useState([]);
    const refTable = useGridApiRef();
    const [dataTable, setDataTable] = useState([]);
    const [dataTableShow, setDataTableShow] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [totalEOCQualify, setTotalEOCQualify] = useState(0)
    const [totalEOCOpen, setTotalEOCOpen] = useState(0)
    const [openLegend, setOpenLegend] = useState(false)
    const [eocLevel, setEOCLevel] = useState("01")
    // const [tableHeader, setTableHeader] = useState([]);

    useEffect(() => {
        let level = 1;
        let eoc_level = "02";
        if (areaLevel === "region") {
            level = 1;
            eoc_level = "02";
        } else if (areaLevel === "province") {
            level = 2;
            eoc_level = "03";
        } else if (areaLevel === "amphur") {
            level = 3;
            eoc_level = "04";
        } else if (areaLevel === "tambon") {
            level = 4;
            eoc_level = "05";
        }
        else eoc_level = "01";

        setEOCLevel(eoc_level);

        const initColumn = () => {
            let tmpColumn = [];
            let pinColumn = []
            pinColumn.push('health_region_name');
            tmpColumn.push({ field: 'health_region_name', headerName: 'สคร.', width: 220 });
            if (level > 1) {
                pinColumn.push('prov_namt');
                tmpColumn.push({ field: 'prov_namt', headerName: 'จังหวัด', width: 160 });
                if (level > 2) {
                    pinColumn.push('amp_namt');
                    tmpColumn.push({ field: 'amp_namt', headerName: 'อำเภอ', width: 160 });
                    if (level > 3) {
                        pinColumn.push('tambon_namt');
                        tmpColumn.push({ field: 'tambon_namt', headerName: 'ตำบล', width: 160 });
                    }
                }
            }
            if (areaLevel !== "tambon") {
                let headerLevel = "จังหวัด";
                if (areaLevel === "province") {
                    headerLevel = "อำเภอ";
                } else if (areaLevel === "amphur") {
                    headerLevel = "ตำบล";
                }
                tmpColumn.push({ field: 'total_count', headerName: `จำนวน${headerLevel}`, type: 'number', width: 100 });
                tmpColumn.push({ field: 'eoc_count', headerName: `${headerLevel}ที่เข้าเกณฑ์ EOC`, type: 'number', width: 150 });
                tmpColumn.push({
                    field: 'eoc_status',
                    headerName: 'เข้าเกณฑ์เปิด EOC',
                    type: 'boolean',
                    width: 120,
                    renderCell: (params) => <RenderEOC {...params} />
                });
                tmpColumn.push({
                    field: 'eoc_start_week',
                    headerName: 'สัปดาห์ที่เข้าเกณฑ์',
                    type: 'number',
                    width: 120,
                    valueGetter: (params) => {
                        if (params.value === 0) {
                            return "-";
                        }
                        return params.value;
                    }
                });
                tmpColumn.push({
                    field: 'eoc_open_status',
                    headerName: 'เปิด EOC',
                    type: 'boolean',
                    width: 120,
                    renderCell: (params) => <RenderEOCisOpened {...params} />
                });
                tmpColumn.push({
                    field: 'eoc_open_week',
                    headerName: 'สัปดาห์ที่เปิด EOC',
                    width: 120,
                    type: 'number'
                });
                tmpColumn.push({
                    field: 'eoc_open_year',
                    headerName: 'ปีที่เปิด EOC',
                    width: 100,
                });
                // tmpColumn.push({ 
                //     field: 'eoc_open_ts', 
                //     headerName: 'วันที่เปิด EOC', 
                //     type: 'Date',
                //     valueGetter: (params) => {
                //         if (params.value !== "") {
                //             return dayjs(params.value).format('YYYY-MM-DD HH:mm:ss');
                //         }
                //         return params.value;
                //     }
                // });
            } else {
                tmpColumn.push({ field: 'patient', headerName: 'จำนวนผู้ป่วย', type: 'number' });
                tmpColumn.push({ field: 'median', headerName: 'มัธยฐาน', type: 'number' });
                tmpColumn.push({ field: 'epidemic_period', headerName: 'ระยะเวลาระบาดต่อเนื่อง (วัน)', type: 'number' });
                tmpColumn.push({
                    field: 'eoc_status',
                    headerName: 'เข้าเกณฑ์เปิด EOC',
                    type: 'boolean',
                    flex: 1,
                    renderCell: (params) => <RenderEOC {...params} />
                });
                tmpColumn.push({
                    field: 'eoc_open_status',
                    headerName: 'เปิด EOC',
                    type: 'boolean',
                    width: 160,
                    flex: 1,
                    renderCell: (params) => <RenderEOCisOpened {...params} />
                });
                tmpColumn.push({
                    field: 'eoc_open_week',
                    headerName: 'สัปดาห์ที่เปิด EOC',
                    flex: 1,
                    type: 'number'
                });
                tmpColumn.push({
                    field: 'eoc_open_year',
                    headerName: 'ปีที่เปิด EOC',
                    flex: 1,
                });
                // tmpColumn.push({ 
                //     field: 'eoc_open_ts', 
                //     headerName: 'วันที่เปิด EOC', 
                //     type: 'Date',
                //     valueGetter: (params) => {
                //         if (params.value !== "") {
                //             return dayjs(params.value).format('YYYY-MM-DD HH:mm:ss');
                //         }
                //         return params.value;
                //     }
                // });
            }
            setColumns(tmpColumn);
            // console.log(pinColumn);
            setPinColumns(pinColumn);
        }
        const callData = async () => {
            setIsLoading(true)
            iaam.getAccessToken(async (err, access_token) => {
                if (!err) {
                    // get the data from the api
                    let options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `bearer ${access_token}`
                        }
                    }
                    const response = await fetch(`${process.env.REACT_APP_API_URL_SECURE}/d506-eoc/${areaLevel}?week=${woy.week}&year=${woy.year}&disease_class=1`, options);
                    const json = await response.json();

                    // get EOC is Opening
                    // const cond = areaSelected.level > 1 ? `&area_code=${areaSelected.value}` : ""
                    const resp = await fetch(`${process.env.REACT_APP_API_URL}/monitor/get_eoc_open_by_weekyear?eoc_level=${eoc_level}&week=${woy.week}&year=${woy.year}`);
                    const eoc_open = await resp.json();
                    // setTotalEOCOpen(eoc_open.length)


                    for (let idx in eoc_open) {
                        const eoc = eoc_open[idx]

                        if (eoc_level === "02") {
                            if (json[eoc.health_region_code]) {
                                json[eoc.health_region_code] = { ...json[eoc.health_region_code], eoc_open_status: true, eoc_open_ts: eoc.create_timestamp, eoc_open_week: eoc.start_eoc_week, eoc_open_year: eoc.start_eoc_year }
                            }
                        }
                        else {
                            if (json[eoc.area_code]) {
                                json[eoc.area_code] = { ...json[eoc.area_code], eoc_open_status: true, eoc_open_ts: eoc.create_timestamp, eoc_open_week: eoc.start_eoc_week, eoc_open_year: eoc.start_eoc_year }
                            }
                        }

                    }
                    // console.log(json)

                    let keys = Object.keys(json);
                    let tmpData = [];
                    for (let index = 0; index < keys.length; index++) {
                        const key = keys[index];
                        let eocData = json[key]

                        if (!eocData?.eoc_open_status) {
                            eocData = { ...eocData, eoc_open_status: false, eoc_open_ts: "-", eoc_open_week: "-", eoc_open_year: "-" }
                        }

                        let regionData = regionMap[eocData.region_code];
                        let provinceData = {};
                        let amphurData = {};
                        let tambonData = {};
                        if (level > 1) {
                            provinceData = provinceMap[eocData.province_code];
                            if (level > 2) {
                                amphurData = amphurMap[eocData.amphur_code];
                                if (level > 3) {
                                    tambonData = tambonMap[eocData.tambon_code];
                                }
                            }
                        }
                        const data = {
                            ...regionData,
                            ...provinceData,
                            ...amphurData,
                            ...tambonData,
                            ...eocData
                        }
                        tmpData.push(data);
                    }
                    const rows = tmpData.map((row, index) => { return { ...row, id: index } })
                    // setTotalEOCQualify(rows.reduce((accumulator, current) => accumulator + current.eoc_status, 0))
                    setDataTable(rows);
                    setIsLoading(false);
                }
                else {
                    iaam.login()
                }
            })
        }
        if (woy !== undefined && Object.keys(tambonMap).length !== 0) {
            initColumn();
            callData();
        }
    }, [areaLevel, woy, regionMap, provinceMap, amphurMap, tambonMap])

    useEffect(() => {
        const filterData = async () => {
            setIsLoading(true)
            if (areaSelected.level === 1) {
                setTotalEOCOpen(dataTable.reduce((accumulator, current) => accumulator + current.eoc_open_status, 0))
                setTotalEOCQualify(dataTable.reduce((accumulator, current) => accumulator + current.eoc_status, 0))
                setDataTableShow([...dataTable]);
            } else {
                let tmpData = [];
                let provinceList = [];
                if (areaSelected.level === 2) {
                    const response = await fetch(`${process.env.REACT_APP_MASTER_API_URL}/area/province?dpc_code=${areaSelected.value}`);
                    provinceList = await response.json();
                }
                for (let index = 0; index < dataTable.length; index++) {
                    const element = dataTable[index];
                    if (areaSelected.level === 2) {
                        let searchIndex = provinceList.findIndex(({ prov_code }) => prov_code === element.prov_code);
                        if (searchIndex !== -1) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 3) {
                        if (element.prov_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 4) {
                        if (element.amp_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 5) {
                        if (element.tambon_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    }
                }
                setTotalEOCOpen(tmpData.reduce((accumulator, current) => accumulator + current.eoc_open_status, 0))
                setTotalEOCQualify(tmpData.reduce((accumulator, current) => accumulator + current.eoc_status, 0))
                setDataTableShow(tmpData);
            }
            setIsLoading(false)
        }
        if (dataTable.length !== 0) {
            filterData();
        }
    }, [dataTable, areaSelected])

    const CustomToolbar = () => {
        // console.log(d506UpdateTime)
        return (
            <GridToolbarContainer className="flex mx-2 justify-between item-center">
                <div className="flex gap-2 item-center">
                    <GridToolbarQuickFilter variant="outlined" size="small" />
                    {/* <Button 
                        // variant="outlined"
                        onClick={() => {
                            refTable.current.autosizeColumns(autoSizeOptions);
                        }}
                        >Auto Size
                    </Button>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector /> */}
                    <GridToolbarExport />
                </div>
                <div className='flex md:justify-end items-end gap-2'>
                    <IconButton onClick={() => setOpenLegend(true)} >
                        <InfoIcon />
                    </IconButton>
                    <div className='min-w-[180px] flex justify-between rounded border-2 border-[#1150A4] py-[6px] px-3 content-center'>
                        <Typography variant='body2' sx={{
                            color: "#1150A4"
                        }}>
                            เข้าเกณฑ์เปิด EOC
                        </Typography>
                        <Typography variant='body2' className='font-bold text-[#1150A4]'>
                            {totalEOCQualify.toLocaleString('en-US')}
                        </Typography>
                    </div>
                    <div className='min-w-[130px] flex justify-between rounded border-2 border-[#cd6c4a] py-[6px] px-3 content-center'>
                        <Typography variant='body2' sx={{
                            color: "#cd6c4a"
                        }}>
                            เปิด EOC
                        </Typography>
                        <Typography variant='body2' className='font-bold text-[#cd6c4a]'>
                            {totalEOCOpen.toLocaleString('en-US')}
                        </Typography>
                    </div>
                    <div className='min-w-[130px] flex justify-between rounded border-2 bg-[#cd6c4a] border-[#cd6c4a] py-[6px] px-3 content-center'>
                        <Typography variant='body2' sx={{
                            color: "#fff"
                        }}>
                            ทั้งหมด
                        </Typography>
                        <Typography variant='body2' className='font-bold text-[#fff]'>
                            {dataTableShow.length.toLocaleString('en-US')}
                        </Typography>
                    </div>
                </div>


            </GridToolbarContainer>
        );
    }


    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <DengueEOCLegeng open={openLegend} eoc_level={eocLevel} onClose={() => setOpenLegend(!openLegend)}/>
            <DataGridPro
                className='border-0'
                apiRef={refTable}
                loading={isLoading}
                rows={dataTableShow}
                columns={columns}
                disableRowSelectionOnClick
                disableDensitySelector
                hideFooter
                disableColumnSelector
                rowHeight={40}
                slots={{ toolbar: CustomToolbar, loadingOverlay: LinearProgress }}
                initialState={{ pinnedColumns: { left: pinColumns } }}
            />
        </Box>
    )

}

export default MonitorTable
